// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__23Bdc","dragIcon":"SortableItem_dragIcon__1w1Oe","disabled":"SortableItem_disabled__1c8w0"};